<template>
  <div class="seciton-information">
    <div class="seciton-information__title">
      <img src="@/assets/images/loto/ticket.png"/>
      <label>YOUR SELECTION</label>
    </div>
    <div class="seciton-information__info">
      <div
          v-for="(item, index) in information"
          :key="index"
          class="seciton-information__item"
      >
        <div class="info-title">{{ item.title }}</div>
        <div v-if="item.id==='entryPerDraw'" :key="item.id" class="info-content">{{entryPerDraw}}</div>
        <div v-else-if="item.id==='totalCost'" :key="item.id" class="info-content">{{totalCost}}</div>
        <div v-else :key="item.id" class="info-content">{{item.value}}</div>


      </div>
    </div>
    <div class="seciton-information__qr-code">
      <button @click="handleShowCalculatePad">Confirm Ticket(s)</button>
    </div>
    <Numpad />
  </div>

</template>

<script>
// import { information } from '@/resources/information';
import toolService from '@/services/tool.service';
import Numpad from "@/components/common/numpad/numpad";
const TICKET_PRICE = process.env.VUE_APP_TICKET_PRICE;
const CURRENCY_CODE = process.env.VUE_APP_CURRENCY_CODE;

export default {
  components: {
    Numpad
  },
  data() {
    return {
      information: [
        {
          id: "nextDrawDate",
          title: "Next Draw Date",
          value: toolService.getDrawDate()
        },
        {
          id: "draws",
          title: "Draws",
          value: 1
        },
        {
          id: "entryPerDraw",
          title: "Entries per Draw",
          value: 1
        },
        {
          id: "costPerEntry",
          title: "Cost per Entry",
          value: toolService.formatAmount(parseFloat(TICKET_PRICE))
        },
        {
          id: "totalCost",
          title: "Total Cost",
          value: this.$store.getters.getTotalAmount
        }
      ]
    }
  },
  computed:{
    entryPerDraw() {
      return this.$store.state.ticketsLength ? this.$store.state.ticketsLength : this.$store.state.tickets.length;
    },
    totalCost() {
      const totalCost = toolService.formatAmount(parseFloat(this.entryPerDraw * TICKET_PRICE));
      // CURRENCY_CODE + " " + this.entryPerDraw * TICKET_PRICE;
      return totalCost;
    }
  },
  watch:{

  },
  methods: {
    handleShowCalculatePad() {
      if (this.$store.state.tickets.length) {
        this.$bvModal.show('modal-center');
      } else {
        this.$bvToast.toast("Please select tickets", {
          title: 'Failed',
          variant: 'danger',
          solid: true,
          autoHideDelay: 3000
        });
      }
    }
  }
}
</script>
